<template>
    <button
        class="button button_theme_content-width button_theme_light button_theme_stroke"
        v-if="borderShow > 0" @click="changePage"
    >
        Загрузить еще
    </button>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Utils from 'common/scripts/utils';

export default {
    props   : ['counterHidden', 'counterFlats'],
    computed: {
        ...mapGetters({page: 'GET_PAGE'}),

        // устанавливает возможное кол-во показываемых квартир
        borderShow() {
            const hidden = this.counterHidden;

            return hidden < this.$appOptions.showItemPage ? hidden : this.$appOptions.showItemPage;
        },

        word() {
            const wordArray = this.isEstateFlat ?
                ['квартиру', 'квартиры', 'квартир'] :
                ['помещение', 'помещения', 'помещений'];

            return Utils.pluralWord(this.borderShow, wordArray);
        }
    },

    methods: {...mapActions(['changePage'])}
};
</script>
